import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the intervention icon
 * 
 * @param {Object} props - The props of the component
 * @returns The intervention icon
 */
const InterventionIcon = (props) => (
  <Icon viewBox="0 0 16 20" fill="none" {...props}>
    <path d="M8 13C8.93333 13 9.775 12.7708 10.525 12.3125C11.275 11.8542 11.8667 11.25 12.3 10.5C11.7167 10.0167 11.0583 9.64583 10.325 9.3875C9.59167 9.12917 8.81667 9 8 9C7.18333 9 6.40833 9.12917 5.675 9.3875C4.94167 9.64583 4.28333 10.0167 3.7 10.5C4.13333 11.25 4.725 11.8542 5.475 12.3125C6.225 12.7708 7.06667 13 8 13ZM8 8C8.55 8 9.02083 7.80417 9.4125 7.4125C9.80417 7.02083 10 6.55 10 6C10 5.45 9.80417 4.97917 9.4125 4.5875C9.02083 4.19583 8.55 4 8 4C7.45 4 6.97917 4.19583 6.5875 4.5875C6.19583 4.97917 6 5.45 6 6C6 6.55 6.19583 7.02083 6.5875 7.4125C6.97917 7.80417 7.45 8 8 8ZM8 20C5.31667 17.7167 3.3125 15.5958 1.9875 13.6375C0.6625 11.6792 0 9.86667 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 9.86667 15.3375 11.6792 14.0125 13.6375C12.6875 15.5958 10.6833 17.7167 8 20Z" fill="currentColor" />
  </Icon>
);

export default React.memo(InterventionIcon);
